import './jquery'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
    auth
} from './firebase'

//import VueMaterial from 'vue-material'
//import 'vue-material/dist/vue-material.css'

//import './assets/scss/app.scss'
import './assets/nav.css'
import './assets/sections.css'
import './assets/calendar.css'
import './assets/theme.css'

for (var key in localStorage) {
    if (key.includes('firebaseio.com')) {
        localStorage.removeItem(key);
    }
}

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.config.productionTip = false

let app
auth.onAuthStateChanged(user => {
    if (!app) {
        app = new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount('#app')
    }

    if (user) {
        store.dispatch('fetchUserProfile', user) // + getClaims + roles + modules + devoirs
    }
})